export const baseUrl = `${document.location.protocol}//${document.location.host}`
